import { config } from "../enviroment";
import axios from "axios";
import { apolloClientService } from "./apollo-client";

  
  export const adminService = {
    getContentData,
    getPaymentTypes
  };


async function getContentData(
    languageCode: string,
    categoryCode: string
  ) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.urls.ADMIN_SERVICE_BASE_URL, {
          query:
            `{getContents(input:{languageCode:"` +
            languageCode +
            `",categoryCode:"` +
            categoryCode +
            `"})}`,
        })
        .then(function(response) {
          resolve(response.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }

  
async function getPaymentTypes(tenantCode,status){
  const queryString =
  `query{
    getPaymentTypes(input: {
        tenantCode:"DPDC",status:"Active"
    }){
        PaymentTypeId
        PaymentGatewayName
        Description
        Url
        Status
        Image
    }
}`
  let res = await apolloClientService.ApolloClientgqls(queryString);
  return res.data;
};
